import { useEffect, useState } from "react";

export const useDebounceValue = (value, delay) => {
  // ** local State
  const [debouncedValue, setDebouncedValue] = useState(value);

  // ** Effects
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
